export default __webpack_public_path__ + "static/media/product-banner.b78cd3b4.jpg";